(function (global, factory) {
  'use strict';

  if (typeof define === 'function' && define.amd) {
    // If supports for AMD is available return the value to the AMD Loader
    // and to the global (window) object in case any JS module is expecting
    // the amenitiesList to exists on the window object.
    define('amenitiesList',[], () => factory(global));
  } else if (typeof exports === 'object') {
    // If supports for Common JS is available export the module
    // and pass is value to the global (window) object in case non Common JS code
    // is expected to work with this amenitiesList.
    module.exports = factory(global);
  } else {
    // If not support for AMD or Common JS is available register the module in the global scope.
    factory(global);
  }
}(
  typeof window !== 'undefined' ? window : {},
  (global) => {
    'use strict';

    global.NewHomeSource = global.NewHomeSource || {};

    const previousAmenitiesList = global.NewHomeSource.AmenitiesList;

    const amenities = {
      Adult: {
        es: 'adultomayor',
        en: 'adult',
        value: 'true'
      },
      Pool: {
        es: 'piscina',
        en: 'pool',
        value: 'true'
      },
      GreenProgram: {
        es: 'ecologica',
        en: 'greenprogram',
        value: 'true'
      },
      GolfCourse: {
        es: 'campodegolf',
        en: 'golfcourse',
        value: 'true'
      },
      Gated: {
        es: 'comunidadcerrada',
        en: 'gated',
        value: 'true'
      },
      NatureAreas: {
        es: 'espacionatural',
        en: 'natureareas',
        value: 'true'
      },
      Views: {
        es: 'vistas',
        en: 'views',
        value: 'true'
      },
      Waterfront: {
        es: 'frenteoceano',
        en: 'waterfront',
        value: 'true'
      },
      Sports: {
        es: 'deportivo',
        en: 'sports',
        value: 'true'
      },
      Parks: {
        es: 'parques',
        en: 'parks',
        value: 'true'
      },
      HotDeals: {
        es: 'ofertas',
        en: 'hotdeals',
        value: 'true',
        isTruthy(parameters) {
          return parameters.HotDeals || (parameters.HomeStatus && parameters.HomeStatus.indexOf('H') > -1);
        }
      },
      Inventory: {
        es: 'inventario',
        en: 'inventory',
        value: 'true',
        isTruthy(parameters) {
          return parameters.Inventory || (parameters.HomeStatus && parameters.HomeStatus.indexOf('UC,A') > -1);
        }
      },
      LuxuryHomes: {
        es: 'lujo',
        en: 'luxury',
        value: 'true'
      },
      Green: {
        es: 'ecologica',
        en: 'green',
        value: 'true'
      },
      AgeRestricted: {
        es: 'restriccionedad',
        en: 'agerestricted',
        value: 'true'
      },
      Modular: {
        es: 'modular',
        en: 'modular',
        value: 'true'
      },
      HasRVGarage: {
        es: 'rvgarage',
        en: 'rvgarage',
        value: 'true'
      },
      CommunityStatus: {
        es: 'pronto',
        en: 'comingsoon',
        value: 'true',
        isTruthy(parameters) {
          return parameters.CommunityStatus && parameters.CommunityStatus.indexOf('C') > -1;
        }
      }
    };
    const language = document.documentElement.lang;

    /**
     * @constructs NewHomeSource.AmenitiesList
     */
    function AmenitiesList() {
    }

    AmenitiesList.getAmenityName = function getAmenityName(name) {
      const amenity = amenities[name];
      if (!amenity) {
        return '';
      }
      return amenity[language];
    };

    AmenitiesList.getAmenities = function getAmenities() {
      const amenitiesArray = [];
      Object.keys(amenities).forEach((amenity) => {
        const amenityName = AmenitiesList.getAmenityName(amenity);
        amenitiesArray.push(amenityName);
      });

      return amenitiesArray;
    };

    AmenitiesList.getAmenityValue = function getAmenityValue(amenity, searchParameters) {
      const originalValue = searchParameters[amenity];
      const functionToEvaluate = amenities[amenity] && amenities[amenity].isTruthy;

      if (functionToEvaluate) {
        return functionToEvaluate(searchParameters);
      }

      return originalValue;
    };

    AmenitiesList.getOriginalAmenities = function getOriginalAmenities() {
      const amenitiesArray = Object.keys(amenities);

      return amenitiesArray;
    };

    AmenitiesList.getQuery = function getQuery(amenity) {
      const amenityWord = AmenitiesList.getAmenityName(amenity);
      const amenityObject = amenities[amenity];

      if (!amenity || !amenityObject) {
        return '';
      }

      const amenityValue = amenityObject.value;
      const query = `${amenityWord}=${amenityValue}`;

      return query;
    };

    /**
     * @public
     *
     * noConflict: Returns control of NewHomeSource.AmenitiesList to the previous script.
     */
    AmenitiesList.noConflict = function noConflict() {
      global.NewHomeSource.AmenitiesList = previousAmenitiesList;
      return AmenitiesList;
    };

    global.NewHomeSource.AmenitiesList = AmenitiesList;

    return AmenitiesList;
  }
));

